import { useState, useEffect, useContext } from 'react';
import toastError from '../../toasts/toastError.js';
import { format, sub } from 'date-fns';
import api from '../../services/api';
import { AuthContext } from '../../context/Auth/AuthContext.jsx';

const useTickets = ({
  searchParam,
  tags,
  users,
  pageNumber,
  status,
  date,
  updatedAt,
  showAll,
  queueIds,
  withUnreadMessages,
  whatsappIds,
  statusFilter,
  forceSearch,
  userFilter,
  sortTickets,
  searchOnMessages,
}) => {
  const [loading, setLoading] = useState(true);
  const [hasMore, setHasMore] = useState(false);
  const [tickets, setTickets] = useState([]);
  const [count, setCount] = useState(0);
  const { isAuth } = useContext(AuthContext);

  useEffect(() => {
    if (!isAuth) return;
    const delayDebounceFn = setTimeout(() => {
      const fetchTickets = async () => {
        setLoading(true);
        if (userFilter === undefined || userFilter === null) {
          try {
            const { data } = await api.get('/tickets', {
              params: {
                searchParam,
                pageNumber,
                tags,
                users,
                status,
                date,
                updatedAt,
                showAll,
                queueIds,
                withUnreadMessages,
                whatsapps: whatsappIds,
                statusFilter,
                sortTickets,
                searchOnMessages,
              },
            });

            let tickets = [];

            tickets = data.tickets;

            setTickets(tickets);
            setHasMore(data.hasMore);
            setCount(data.count);
          } catch (err) {
            toastError(err);
          } finally {
            setLoading(false);
          }
        } else {
          try {
            const { data } = await api.get('/dashboard/moments', {
              params: {
                status,
                showAll,
                queueIds,
                dateStart: format(sub(new Date(), { days: 30 }), 'yyyy-MM-dd'),
                dateEnd: format(new Date(), 'yyyy-MM-dd'),
                userId: userFilter,
              },
            });

            let tickets = [];
            tickets = data.filter((item) => item.userId === userFilter);

            setTickets(tickets);
            setHasMore(null);
          } catch (err) {
            toastError(err);
          } finally {
            setLoading(false);
          }
        }
      };
      fetchTickets();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [
    searchParam,
    tags,
    users,
    pageNumber,
    status,
    date,
    updatedAt,
    showAll,
    queueIds,
    withUnreadMessages,
    whatsappIds,
    statusFilter,
    forceSearch,
    sortTickets,
    searchOnMessages,
    userFilter,
    isAuth,
  ]);

  return { tickets, loading, hasMore, count };
};

export default useTickets;
